import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";


class RemoveArticleSalePriceStore {

    public salePriceId: string;
    public articleSalePriceId: string;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, salePriceId: string, articleSalePriceId: string) {
        this.salePriceId = salePriceId;
        this.articleSalePriceId = articleSalePriceId;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }


    @action
    public async remove() {
        const response = await SalePriceService.removeArticleSalePrice(this.salePriceId, this.articleSalePriceId);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default RemoveArticleSalePriceStore;

